import { Component, EventEmitter, OnDestroy, OnInit, Output, ViewChild } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';
import { DatatableComponent } from '@swimlane/ngx-datatable';
import { BsModalService } from 'ngx-bootstrap';
import { ToastrService } from 'ngx-toastr';
import { Observable } from 'rxjs';
import { first } from 'rxjs/operators';
import { ComboCliente, ComboGrupo, ComboInformesTipos } from '../../core/model/combos';
import {
  InformesSearch, InformeContabilidadConsultas, FiltroInformeContabilidadConsultas, InformeConsultas,
  InformeContabilidadConsultasContenido
} from '../../core/model/informes';
import { ResizedEvent } from '../../core/model/resized-event';
import { AuthenticationService } from '../../core/services/authentication.service';
import { FileDownloaderService, FileQueueObject } from '../../core/services/informes/file-downloader.service';
import { InformesService } from '../../core/services/informes/informes.service';
import { PopulateService } from '../../core/services/populate.service';
import { ModalConfirmationComponent } from '../../utils/modal-confirmation/modal-confirmation.component';
import { UsersService } from '../../core/services/users.service';
import { UsuarioCliente } from '../../core/model/usuario-cliente';
import { formControlBinding } from '@angular/forms/src/directives/ng_model';



@Component({
  selector: 'app-informes',
  templateUrl: './informes.component.html',
  styleUrls: ['./informes.component.css'],
  providers: [InformesService, PopulateService, FileDownloaderService]
})

export class InformesComponent implements OnInit, OnDestroy {
  @ViewChild('table') table: DatatableComponent;

  @Output() CompleteItem = new EventEmitter();
  @Output() ErrorItem = new EventEmitter();
  @Output() ProgressItem = new EventEmitter();
  @Output() CancelItem = new EventEmitter();
  @Output() DeleteItem = new EventEmitter();

  queue: Observable<FileQueueObject[]>;

  Boxtype = 'box-primary';
  Title: string;
  Description: string;
  Padre: string;
  Hijo: string;

  tamanioRecuperar = 10;

  isDocoutUser: boolean;

  informeSearch: InformesSearch = new InformesSearch();
  months: any;
  years: any;

  cbCliente: ComboCliente[];
  cbGrupo: ComboGrupo[];
  cbtipoInformes: ComboInformesTipos[];
  selectedReport: any = '-1';
  downloadedReport: any;

  clienteSeleccionadoInforme: any;
  grupoSeleccionadoInforme: ComboGrupo;
  usuarioSeleccionadoInforme: any;
  cbGrupoContabilidad: ComboGrupo[];
  cbUsuarios: UsuarioCliente[];

  grafico: any;

  statusCode: number;
  requestProcessing = false;
  requestProcessingTipo = false;
  noHayInformes = false;
  processValidation = false;
  mensajeToShow: string;
  mensajeToShow2: string;
  nombre: string;

  informeContabilidadConsultas: InformeConsultas;
  colorScheme = {
    domain: ['#5AA454', '#E44D25', '#CFC0BB', '#7aa3e5', '#a8385d', '#aae3f5']
  };
  view: any[] = [500, 400];
  viewchar: any[] = [1000, 400];
  showLegend = true;
  showLabels = true;

  clienteSeleccionado = undefined;

  private subscription;
  private subscription_change;
  private subscription_tipos;
  private subscription_informes;
  private subscription_clientes;
  private subscription_grupos;

  showAutogenerationButton: boolean;

  // Creamos el formulario
  filterForm = new FormGroup({
    cliente: new FormControl('-1'),
    grupo: new FormControl(undefined),
    tipo: new FormControl('-1'),
    mes: new FormControl('-1'),
    ano: new FormControl('-1')
  });

  filterFormContabilidad = new FormGroup({
    clientecontable: new FormControl('-1'),
    grupocontable: new FormControl('-1'),
    solicitantecontable: new FormControl('-1'),
    fechaAltaInicial: new FormControl(undefined),
    fechaAltaFinal: new FormControl(undefined)
  });

  sumatorioFinalContabilidad = new FormGroup({
    sumatorioLocalizadas: new FormControl(0),
    sumatorioBusquedas: new FormControl(0)
  });

  loading = false;

  constructor(
    private informesservice: InformesService,
    private toastr: ToastrService,
    private translateService: TranslateService,
    private populateService: PopulateService,
    private authService: AuthenticationService,
    private downloader: FileDownloaderService,
    private modalservice: BsModalService,
    private userService: UsersService
  ) {
    this.getMonth();
    this.getYears();
  }


  // region "Initialize"
  ngOnInit() {
    this.authService.isDocOutUser()
      .then((isDocUser: boolean) => {
        this.isDocoutUser = isDocUser;
        this.InitDownloader();
        this.InitLanguage();
        this.getFilters();
        this.getAllInformes();
      });
    this.Padre = this.authService.getClienteName();
  }

  InitDownloader() {
    this.downloader.onCompleteItem = this.completeItem;
    this.downloader.onErrorItem = this.errorItem;
    this.downloader.onProgressItem = this.progressItem;
    this.downloader.onCancelItem = this.cancelItem;
    this.downloader.onDeleteItem = this.deleteItem;
    this.downloader.onErrorDeleteItem = this.errorDeleteItem;
  }
  InitLanguage() {
    this.subscription = this.translateService.get(['informes'])
      .subscribe(values => { this.TranslateText(values); });

    this.subscription_change = this.translateService.onLangChange.subscribe(() => {
      this.translateService.get(['informes'])
        .subscribe(values => { this.TranslateText(values); });
    });
  }

  TranslateText(values: any) {
    this.Title = values['informes']['cabecera'];
    this.Description = values['informes']['downdescripcion'];
    this.Hijo = values['informes']['cabecera'];
  }
  // Sacar a modulo utilidades junto con los populate combo?¿?¿?¿?
  getMonth() {
    this.months = [
      { id: 1, name: 'Enero' },
      { id: 2, name: 'Febrero' },
      { id: 3, name: 'Marzo' },
      { id: 4, name: 'Abril' },
      { id: 5, name: 'Mayo' },
      { id: 6, name: 'Junio' },
      { id: 7, name: 'Julio' },
      { id: 8, name: 'Agosto' },
      { id: 9, name: 'Septiembre' },
      { id: 10, name: 'Octubre' },
      { id: 11, name: 'Noviembre' },
      { id: 12, name: 'Diciembre' }
    ];
    this.translateService.get(['meses']).pipe(first())
      .subscribe(values => {
        for (let i = 0, len = this.months.length; i < len; i++) {
          this.months[i].name = values['meses'][this.months[i].id];
        }
      });
  }

  getYears() {
    this.years = [];
    const actual = new Date().getFullYear();
    for (let x = 0; x <= 5; x++) {
      this.years.push({ value: actual - x, name: '' + (actual - x) });
    }
  }

  // endregion


  // region "Filters/Combos"
  getGroupByCliente(identificador: number) {
    this.subscription_grupos = this.populateService.getComboGrupoByCliente(identificador)
      .subscribe(
        grupo => {
          this.cbGrupo = grupo;
        },
        errorCode => {
          this.statusCode = 500; // errorCode
          this.subscription = this.translateService.get(['mensajes'])
            .subscribe(values => {
              this.toastr.warning(values['mensajes']['nodata'],
                values['mensajes']['nodatatitle']);
            });
        });


  }

  getClientes() {
    this.subscription_clientes = this.populateService.getComboCliente()
      .subscribe(
        clientes => {
          this.cbCliente = clientes;
        },
        errorCode => {
          this.statusCode = 500; // errorCode
          this.subscription = this.translateService.get(['mensajes'])
            .subscribe(values => {
              this.toastr.warning(values['mensajes']['nodata'],
                values['mensajes']['nodatatitle']);
            });
        });
  }

  getFilters() {
    if (this.isDocoutUser) {
      this.getClientes();
    }
    this.getTipoInformes();
  }

  getTipoInformes() {
    this.preProcessInformesTipo('Recuperando filtros..');
    this.subscription_tipos = this.populateService.getComboTipoInformes()
      .subscribe(
        data => {
          this.cbtipoInformes = data;
          this.requestProcessingTipo = false;
          // this.toastr.info('Direcciones cargadas correctamente', 'Carga correcta');
        },
        errorCode => {
          this.statusCode = 500; // errorCode
          this.subscription = this.translateService.get(['mensajes'])
            .subscribe(values => {
              this.toastr.warning(values['mensajes']['nodata'],
                values['mensajes']['nodatatitle']);
            });
        });
  }

  cleanFiltroContabilidad() {
    this.filterFormContabilidad.patchValue({
      fechaAltaInicial: undefined,
      fechaAltaFinal: undefined,
      solicitantecontable: undefined,
      grupocontable: undefined,
      clientecontable: undefined
    });
    this.cbGrupoContabilidad = [];
    this.cbUsuarios = [];
    this.getInformeContabilidad(0);
  }

  getInformeContabilidad(from: number) {
    const filtro = new FiltroInformeContabilidadConsultas();
    filtro.CLIENTE = this.filterFormContabilidad.controls['clientecontable'].value;
    filtro.FECHA_ALTA_INICIO = this.filterFormContabilidad.controls['fechaAltaInicial'].value;
    filtro.FECHA_ALTA_FINAL = this.filterFormContabilidad.controls['fechaAltaFinal'].value;
    filtro.SOLICITANTE = this.filterFormContabilidad.controls['solicitantecontable'].value;
    filtro.GRUPO = this.filterFormContabilidad.controls['grupocontable'].value;
    this.sumatorioFinalContabilidad.patchValue({ sumatorioLocalizadas: 0, sumatorioBusquedas: 0 });

    this.loading = true;

    this.informesservice.getInformeContabilidadConsultas(filtro, from, this.tamanioRecuperar)
      .subscribe(
        (r: InformeConsultas) => {
          let sumatorioLoc = 0;
          let sumatorioBus = 0;
          r.INFORME.map(
            (INFORME: InformeContabilidadConsultas) => {
              INFORME.LOCALIZADOS = this.getLocalizados(INFORME.CONTENIDOS);
              INFORME.BUSQUEDAS = this.getBusquedas(INFORME.CONTENIDOS);
              sumatorioLoc += INFORME.LOCALIZADOS;
              sumatorioBus += INFORME.BUSQUEDAS;
            }
          );
          this.informeContabilidadConsultas = r;
          this.sumatorioFinalContabilidad.patchValue({ sumatorioLocalizadas: sumatorioLoc, sumatorioBusquedas: sumatorioBus });
        },
        (e: Error) => this.toastr.error('Ha ocurrido un error al recuperar los datos del informe de consultas. Detalle =>' + e.message),
        () => this.loading = false
      );
  }

  getAllInformes() {
    this.preProcessConfigurations('Cargando informes... Espere por favor.');
    this.subscription_informes = this.informesservice.getAllInformes(this.informeSearch)
      .subscribe(
        data => {
          this.downloader.clearQueue();
          for (let index = 0; index < data.length; index++) {
            this.downloader.addToQueue(data[index]);
            this.noHayInformes = false;
          }
          this.requestProcessing = false;
          if (data.length <= 0 || data == null) {
            this.noHayInformes = true;
          }
          this.queue = this.downloader.queue;
        },

        errorCode => {
          this.statusCode = 500; // errorCode
          this.noHayInformes = true;
          this.subscription = this.translateService.get(['mensajes'])
            .subscribe(values => {
              this.toastr.warning(values['mensajes']['noinformes'],
                values['mensajes']['noinformestitle']);
            });
        });
  }


  // endregion


  // Perform preliminary processing configurations
  preProcessConfigurations(mensaje: string) {
    this.statusCode = null;
    this.requestProcessing = true;
    this.mensajeToShow2 = mensaje;
  }
  preProcessInformesTipo(mensaje: string) {
    this.statusCode = null;
    this.requestProcessingTipo = true;
    this.mensajeToShow = mensaje;
  }

  resetForm() {
    if (this.filterForm != null) {
      this.filterForm.setValue({
        cliente: '-1',
        grupo: null,
        tipo: '-1',
        mes: '-1',
        ano: '-1'
      });
      // Reiniciamos combos dependientes
      this.onClientChange(undefined);
    }
  }

  onClientChange(idcliente: number) {
    this.filterForm.patchValue({ grupo: undefined });
    this.cbGrupo = [];
    // if ( !isNaN(idcliente) && Number(idcliente)) {
    //     this.getGroupByCliente(idcliente);
    //   }
    if (idcliente && idcliente != 0) {
      this.getGroupByCliente(idcliente);
    }
  }

  onClientContabilidadChange(event) {
    this.filterFormContabilidad.patchValue({ grupocontable: undefined });
    this.filterFormContabilidad.patchValue({ solicitantecontable: undefined });
    this.cbGrupoContabilidad = [];
    this.cbUsuarios = [];
    if (this.clienteSeleccionadoInforme !== undefined && this.clienteSeleccionadoInforme !== null) {
      this.populateService.getComboGrupoByCliente(this.clienteSeleccionadoInforme)
        .subscribe(
          (r: ComboGrupo[]) => {
            this.cbGrupoContabilidad = r;
          },
          (e: Error) => this.toastr.error('No se ha podido recuperar los grupos del cliente seleccionado'));
      this.userService.getUsersByClient(this.clienteSeleccionadoInforme)
        .subscribe(
          (r: UsuarioCliente[]) => {
            this.cbUsuarios = r;
          },
          (e: Error) => this.toastr.error('Ha ocurrido un error al obtener los usuarios del cliente seleccionado')
        );
    }
  }


  searchForm() {
    // rellenamos el filtro InformesSearch
    this.informeSearch.ANO = this.filterForm.controls['ano'].value === '-1' ? null : this.filterForm.controls['ano'].value;
    this.informeSearch.ID_CLIENTE = this.filterForm.controls['cliente'].value === '-1' ? null : this.filterForm.controls['cliente'].value;
    this.informeSearch.ID_GRUPO = this.filterForm.controls['grupo'].value === '-1' ? null : this.filterForm.controls['grupo'].value;
    this.informeSearch.ID_TIPO_INFORME = this.filterForm.controls['tipo'].value.Id === '-1' ? null : this.filterForm.controls['tipo'].value.Id;
    this.informeSearch.MES = this.filterForm.controls['mes'].value === '-1' ? null : this.filterForm.controls['mes'].value;
    // llamaos a la funcion
    // this.downloader.clearQueue();
    this.getAllInformes();
  }

  // region "Callback de las actions / delegate"


  deleteItem = (item: FileQueueObject) => {
    this.DeleteItem.emit({ item });
    this.toastr.success('Se ha eliminado el informe ' + item.file.FILENAME, 'Borrado correcto');
    this.getAllInformes();
  }

  completeItem = (item: FileQueueObject, response: any) => {
    this.CompleteItem.emit({ item, response });
    if (item.file.FILENAME === null) { this.nombre = 'default.xls'; } else { this.nombre = item.file.FILENAME; }
    this.toastr.success('Se ha descargado su informe ' + this.nombre, 'Descarga correcta');
    this.saveAs(this.nombre, response);
    // this.saveAs(item.file.FILENAME, response);
  }

  errorDeleteItem = (item: FileQueueObject, response: any) => {
    this.ErrorItem.emit({ item, response });
    this.toastr.error('No se ha podido eliminar su informe ' + item.file.FILENAME, 'Borrado erróneo');
  }

  errorItem = (item: FileQueueObject, response: any) => {
    this.ErrorItem.emit({ item, response });
    this.toastr.error('No se ha podido descargar su informe ' + item.file.FILENAME, 'Descarga errónea');
  }

  progressItem = (item: FileQueueObject) => {
    this.ProgressItem.emit({ item });
  }

  cancelItem = (item: FileQueueObject) => {
    this.CancelItem.emit({ item });
    this.toastr.warning('Cancelando descarga...', 'Descarga cancelada');
  }

  addToQueue() {
    // const fileBrowser = this.fileInput.nativeElement;
    // this.downloader.addToQueue(fileBrowser.files);
  }

  saveAs(fileName: string, data: any) {
    const a: HTMLAnchorElement = document.createElement('a') as HTMLAnchorElement;
    const blob = new Blob([data], { type: 'application/octet-stream' });
    let objectUrl = '';
    if (window.navigator && window.navigator.msSaveOrOpenBlob) {
      // save file for IE
      window.navigator.msSaveOrOpenBlob(blob, fileName);
    } else {
      // save for other browsers: Chrome, Firefox
      objectUrl = URL.createObjectURL(blob);
      // window.open(objectUrl);
      a.href = objectUrl;
      a.download = fileName;
      document.body.appendChild(a);
      a.click();
    }
    document.body.removeChild(a);
    URL.revokeObjectURL(objectUrl);

  }

  onReportChange(report) {
    if (report) {
      this.selectedReport = report;
      this.showAutogenerationButton = report.AUTOGENERACION;
    }
  }

  autoGenerateReport() {
    if (this.selectedReport && this.selectedReport.Id) {
      this.downloadedReport = this.selectedReport;
      this.informesservice.getAutogenerateReport(this.selectedReport.Id)
        .subscribe(response => {
          const fileName = this.downloadedReport.NOMBRE + '.xlsx';
          this._downloadBlob(response, fileName);
        });
    }
  }

  private _downloadBlob(data: any, fileName: string) {
    if (window.navigator.msSaveOrOpenBlob) {
      window.navigator.msSaveOrOpenBlob(data, fileName);
    } else {
      const link = document.createElement('a');
      link.setAttribute('type', 'hidden');
      link.download = fileName;
      link.href = window.URL.createObjectURL(data);
      document.body.appendChild(link);
      link.click();
    }

  }

  // endregion



  // region "Confirmation Modal"
  public showConfirmationModal(item: FileQueueObject): void {
    const modal = this.modalservice.show(ModalConfirmationComponent);
    (<ModalConfirmationComponent>modal.content).showConfirmationModal(
      'Eliminar informe',
      'Va a eliminar el informe ' + item.file.FILENAME + '. ¿Desea eliminarlo?',
      '',
      'Si',
      'No',
      true,
      'fa-exclamation-triangle fa-3x',
      'bg-danger'
    );

    (<ModalConfirmationComponent>modal.content).onClose.subscribe(result => {
      if (result === true) {
        // when pressed Yes
        item.delete();
      } else if (result === false) {
        // when pressed No
      } else {
        // When closing the modal without no or yes
      }
    });
  }

  // endregion

  onResized(event: ResizedEvent): void {
    if (this.table !== undefined) {
      setTimeout(() => {
        this.table.recalculate();
        window.dispatchEvent(new Event('resize'));
      }, (50));
    }
  }

  ngOnDestroy() {
    // console.log('Clear informes');
    if (this.subscription != null) { this.subscription.unsubscribe(); }
    if (this.subscription_change != null) { this.subscription_change.unsubscribe(); }
    if (this.subscription_tipos != null) { this.subscription_tipos.unsubscribe(); }
    if (this.subscription_informes != null) { this.subscription_informes.unsubscribe(); }
    if (this.subscription_clientes != null) { this.subscription_clientes.unsubscribe(); }
    if (this.subscription_grupos != null) { this.subscription_grupos.unsubscribe(); }
    this.translateService = null;
    this.populateService = null;
    this.informesservice = null;
    this.toastr = null;
    this.downloader.clearQueue();
    this.downloader = null;
    this.queue = null;
    this.CompleteItem = null;
    this.ErrorItem = null;
    this.CancelItem = null;
    this.ProgressItem = null;
    this.DeleteItem = null;
  }

  onSelect(event) {
    console.log(event);
  }

  getLocalizados(CONTENIDO: InformeContabilidadConsultasContenido[]): number {
    let SUMATORIO = 0;
    if (CONTENIDO.length > 0) {
      CONTENIDO.forEach(con => {
        if (con.CONTABILIDAD !== null && con.CONTABILIDAD.length > 0) {
          con.CONTABILIDAD.forEach(cont => {
            if (cont.DESCRIPCION === 'Total Localizados') {
              SUMATORIO += cont.CANTIDAD;
            }
          });
        }
      });
    }
    return SUMATORIO;
  }

  getBusquedas(CONTENIDO: InformeContabilidadConsultasContenido[]): number {
    let SUMATORIO = 0;
    if (CONTENIDO.length > 0) {
      CONTENIDO.forEach(con => {
        if (con.CONTABILIDAD !== null && con.CONTABILIDAD.length > 0) {
          con.CONTABILIDAD.forEach(cont => {
            if (cont.DESCRIPCION === 'Total de Búsquedas') {
              SUMATORIO += cont.CANTIDAD;
            }
          });
        }
      });
    }
    return SUMATORIO;
  }

}
